// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {Component, PropTypes} from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

// import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

// action creators for redux
import * as syncActionCreators from '../../../../../redux/actionCreators/sync';
import * as asyncActionCreators from '../../../../../redux/actionCreators/async';

// js utilities
import prettyPhone from '../../../../../lib/prettyPhone';
import _, {get, debounce} from 'lodash';

// classname utilities
// import cx from 'classnames';

// app components
import ModalForm from '../../../../../common/components/c_ModalForm';
import InfoModal from '../../../../../common/components/f_InfoModal';

// different modals
import PasswordEntry from './c_PasswordEntry';
import WaitingSequence from './c_WaitingSequence';
import AlreadyExists from './f_AlreadyExists';
import WelcomeMessage from './f_WelcomeMessage';
import UnqualifiedMessage from './f_UnqualifiedMessage';
import DuplicateAndUnqualified from './f_DuplicateAndUnqualified';


@connect(store => ({
  isQualified: store.prelimApplication.isQualified,
  alreadyExists: store.prelimApplication.alreadyExists,
  isDupAndInWaiting: store.prelimApplication.isDupAndInWaiting,
  isDupQualifiedAndUnresponsive: store.prelimApplication.isDupQualifiedAndUnresponsive,
  isDupAndUnqualified: store.prelimApplication.isDupAndUnqualified,
  passwordIsReady: store.prelimApplication.passwordIsReady,
  userSection: store.prelimApplication.user,
  profileSection: store.prelimApplication.profile,
  assignedSpecialist: store.prelimApplication.assignedSpecialist,
  qualifyingSpecialists: get(store, 'staticData.qualifyingSpecialists', []),
  roles: get(store, 'staticData.employeeRoles', []),
  labels: get(store.labels, 'Common', {}),
  messageLabels: get(store.labels, 'PrelimForm.createUserMessages', {}),
}))
export default class CreateUserModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    closeFunction: PropTypes.func.isRequired,
    userSection: PropTypes.object,
    profileSection: PropTypes.object,
    assignedSpecialist: PropTypes.object,
    isQualified: PropTypes.any,
    alreadyExists: PropTypes.bool,
    isDupAndInWaiting: PropTypes.bool,
    isDupQualifiedAndUnresponsive: PropTypes.bool,
    isDupAndUnqualified: PropTypes.bool,
    passwordIsReady: PropTypes.bool,
    closeModal: PropTypes.func,
    labels: PropTypes.object.isRequired,
    messageLabels: PropTypes.object.isRequired
  }

  constructor(props, context) {
    super(props, context);

    this.updatePassword = ::this.updatePassword;
    this.submitApplicant = ::this.submitApplicant;
    this.debouncedSubmitApplicant = ::this.debouncedSubmitApplicant;
    this.goToLogin = ::this.goToLogin;
    this.endWaitingSequence = ::this.endWaitingSequence;
    this.getCurrentModal = ::this.getCurrentModal;
  }

  state = {
    disableUserClosing: false,
    isWaiting: false,
    transparentMessage: false
  }

  componentWillUpdate(newProps, newState) {
    if(this.getCurrentModal(newProps, newState) !== this.getCurrentModal()) {
      this.setState(_.assign(this.state, {
        transparentMessage: true
      }));
      setTimeout(() => this.setState(_.assign(this.state, {
        transparentMessage: false
      })), 450);
    }
  }

  componentWillUnmount() {
    // reset state after close
    this.props.dispatch(syncActionCreators.updatePrelimForm({
      isQualified: 'unsubmitted'
    }));
  }

  onClose() {
    if(!this.state.userCantClose) {
      // redirect them to homepage if they try to exit the modal and they already exist or are unqualified
      if((!this.props.isQualified || this.props.alreadyExists) && process.env.CLIENT) {
        return this.directToHomePage();
      }

      // need to reset password's state if closed without submitting password
      if(this.props.isQualified === 'unsubmitted') {
        this.refs.passwordEntry.resetPasswordState();
        this.updatePassword('');
      }

      // closes modal with function passed in from parent
      this.props.closeFunction();
    }
  }

  getCurrentModal(newProps, newState) {
    const props = newProps || this.props;
    const state = newState || this.state;

    return state.isWaiting === true ? 'waiting' :
          props.isDupAndInWaiting === true ? 'isDupAndInWaiting' :
          props.isDupQualifiedAndUnresponsive === true ? 'isDupQualifiedAndUnresponsive' :
          props.isDupAndUnqualified === true ? 'isDupAndUnqualified' :
          props.alreadyExists === true ? 'alreadyExists' :
          props.isQualified === 'unsubmitted' ? 'passwordEntry' :
          props.isQualified ? 'qualified' :
          'unqualified';
  }

  getQualifyingSpecialist() {
    const assignedSpecialist = get(this.props, 'assignedSpecialist');
    if (assignedSpecialist) {
      return assignedSpecialist;
    }

    const qsRole = get(this.props, 'roles', []).find(r => r.name === 'Qualifying Specialist') || {};
    const defaultQS = get(this.props, 'qualifyingSpecialists', [])
      .find(qs => qs.defaultRole === qsRole.id)
    ;

    if (defaultQS) {
      return defaultQS;
    }

    return get(this.props, 'qualifyingSpecialists', [])[0]; // Default to the first QS in the list.

  }

  updatePassword(password, passwordIsReady) {
    this.props.dispatch(syncActionCreators.updatePrelimForm({
      user: {password},
      passwordIsReady
    }));
  }

  // fire submitApplicant immediately and not again for 5000ms
  // leading calls fn immediately
  // trailing calls fn at end of wait if multiple invokations were requested during wait
  // we want only 1 call so leading=true and trailing=false
  debouncedSubmitApplicant = debounce(() => {
    this.submitApplicant();
  }, 5000, {leading: true, trailing: false})

  submitApplicant() {
    this.setState({
      disableUserClosing: true // ,
      // isWaiting: true
    });
    this.props.dispatch(asyncActionCreators.submitApplicant({
      user: this.props.userSection,
      profile: this.props.profileSection
    }));
  }

  goToLogin() {
    this.props.closeFunction();
    this.props.dispatch(push('/login'));
  }

  endWaitingSequence() {
    this.setState({
      disableUserClosing: false,
      isWaiting: false
    });
  }

  directToHomePage() {
    window.location = this.props.labels.website; // direct user to WAHVE homepage
  }

  modalFormData = {
    passwordEntry: {
      prompt: 'Create a signin to complete the Preliminary Profile process',
      style: {
        'min-height': '596px'
      },
      button: {
        label: 'Continue',
        onClick: ::this.debouncedSubmitApplicant
      }
    },
    waiting: {
      button: {
        hide: true
      }
    },
    qualified: {
      style: {
        height: '534.5px'
      },
      button: {
        className: 'mobile-hide',
        label: 'View Profile',
        onClick: ::this.goToLogin
      },
      afterButtonText: {
        className: 'mobile-only',
        content: 'Return to wahve.com',
        onClick: ::this.directToHomePage
      },
      onClose: ::this.directToHomePage
    },
    isDupAndUnqualified: {
      button: {
        label: 'Close',
        onClick: ::this.directToHomePage
      },
      onClose: ::this.directToHomePage
    },
    unqualified: {
      button: {
        label: 'Close',
        onClick: ::this.directToHomePage
      },
      onClose: ::this.directToHomePage
    },
    alreadyExists: {
      button: {
        hide: true
      },
      afterButtonText: {
        className: 'mobile-only',
        content: 'Return to wahve.com',
        onClick: ::this.directToHomePage
      },
      onClose: ::this.directToHomePage
    }
  };

  render() {
    // determine current modal state
    const currentModal = this.getCurrentModal();

    // for determining whether password submit button is disabled, need to add this here, tried doing getter, doesn't work
    this.modalFormData.passwordEntry.button.disabled = !this.props.passwordIsReady;

    const qualifyingSpecialist = this.getQualifyingSpecialist();
    const qsNumber = qualifyingSpecialist.direct_dial ? qualifyingSpecialist.direct_dial : qualifyingSpecialist.phoneNumber;
    qualifyingSpecialist.direct_dial = prettyPhone(qsNumber);

    return (
      <ModalForm key='blahblah'
                 message={currentModal !== 'passwordEntry'}
                 {...this.modalFormData[currentModal]}
                 transparent={this.state.transparentMessage}>
        {/* <ReactCSSTransitionGroup className='fadein-Container' transitionName='fadein' transitionEnterTimeout={300} transitionLeaveTimeout={300} transitionAppear transitionAppearTimeout={300}>*/}
          {
              currentModal === 'waiting'
              &&
              <WaitingSequence endFunc={this.endWaitingSequence}/>
            ||
              currentModal === 'isDupQualifiedAndUnresponsive'
              &&
              <InfoModal
                text={_.template(this.props.messageLabels.isDupQualifiedAndUnresponsive)({assignedSpecialist: qualifyingSpecialist})}
                transitionFunc={::this.directToHomePage}
                cancelFunc={::this.directToHomePage}
              />
            ||
              currentModal === 'isDupAndInWaiting'
              &&
              <InfoModal
                text={_.template(this.props.messageLabels.isDupAndInWaiting)({assignedSpecialist: qualifyingSpecialist})}
                transitionFunc={::this.directToHomePage} // reroute to tenant homepage
                cancelFunc={::this.directToHomePage} // reroute to tenant homepage
                buttonLabel={'Close'}
              />
            ||
            currentModal === 'isDupAndUnqualified'
              &&
              <DuplicateAndUnqualified
                message={this.props.messageLabels.isDupAndUnqualified}
              />
            ||
              currentModal === 'alreadyExists'
              &&
              <AlreadyExists firstName={this.props.userSection.firstName} assignedSpecialist={qualifyingSpecialist}/>
            ||
              currentModal === 'passwordEntry'
              &&
              <PasswordEntry ref='passwordEntry'
                             email={this.props.userSection.email}
                             password={this.props.userSection.password}
                             passwordIsReady={this.props.passwordIsReady}
                             updatePassword={this.updatePassword}/>
            ||
              currentModal === 'qualified'
              &&
              <WelcomeMessage/>
            ||
              currentModal === 'unqualified'
              &&
              <UnqualifiedMessage/>
          }
        {/* </ReactCSSTransitionGroup>*/}
      </ModalForm>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/f_PreliminaryApplication/f_Application/r_ApplicationForm/r_CreateUserModal/index.js